export default __webpack_public_path__ + "static/media/my-badges.d49a4456.svg";